import {AElement} from "./AElement";
import {EElementType} from "../utils/EElementType";
import ModelsRegExp from "../../services/ModelsRegExp";

export class EnergyBox extends AElement {

    private _eLoraId: string;

    constructor(serialNumber: string, eLoraId: string, isScanned?: boolean) {
        super(EElementType.EnergyBox, serialNumber, isScanned, ModelsRegExp.elementSerialNumberEnergyBox);
        this._eLoraId = EnergyBox.convertLoraIdWithoutSeparator(eLoraId);
    }

    get eLoraId(): string {
        return this._eLoraId;
    }

    set eLoraId(value: string) {
        this._eLoraId = EnergyBox.convertLoraIdWithoutSeparator(value);
    }

    public static remapObjectToElement(object: any): EnergyBox | null {
        let element: EnergyBox | null = null;
        if(
            object._serialNumber &&
            object._eLoraId
        ) {
            element = new EnergyBox(
                object._serialNumber,
                object._eLoraId,
                object._isScanned
            );
        }
        return element;
    }

    /**
     * Checks if a lora id has a correct format.
     * @returns {boolean} True if the lora id has a correct format and false otherwise.
     */
    public isLoraIdRightFormat(): boolean {
        return EnergyBox.isLoraIdRightFormat(this.eLoraId);
    }

    /**
     * Checks if a lora id has a correct format.
     * @returns {boolean} True if the lora id has a correct format and false otherwise.
     */
    public static isLoraIdRightFormat(loraId: string): boolean {
        let isRight = false;
        const resultWithSeparator = ModelsRegExp.elementLoraIdEnergyBoxWithSeparator.exec(loraId);
        const resultWithoutSeparator = ModelsRegExp.elementLoraIdEnergyBoxWithoutSeparator.exec(loraId);
        if(resultWithSeparator || resultWithoutSeparator) {
            isRight = true;
        }
        return isRight;
    }

    public static isSerialNumberRightFormat(serialNumber: string): boolean {
        return !!ModelsRegExp.elementSerialNumberEnergyBox.exec(serialNumber);
    }

    /**
     * Automatically convert a lora id with the symbol ":" every two characters.
     * @param {string} loraId Lora id to convert.
     * @return {string} Lora id converted.
     * @private
     */
    private static convertLoraIdWithoutSeparator(loraId: string): string {
        let convertedLoraId = loraId;
        const resultWithoutSeparator = ModelsRegExp.elementLoraIdEnergyBoxWithoutSeparator.exec(loraId);
        if(resultWithoutSeparator) {
            const regex = /.{2}(?=.)/g;
            convertedLoraId = loraId.replace(regex, '$&:');
        }
        return convertedLoraId;
    }

    isCorrect(): boolean {
        return (
            super.isCorrect() &&
            this.isLoraIdRightFormat()
        );
    }
}

